import React, { useEffect, useState } from "react";
import { TextField, Autocomplete, MenuItem } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowDownOutlinedIcon from '@mui/icons-material/KeyboardArrowDownOutlined';
import axios from 'axios';
import { useContextStateManagement } from "../context/ContextApi";
import { useDispatch } from "react-redux";
import { logout } from "../features/userSlice";
import { useNavigate } from "react-router-dom";
import { TimeZoneDropdown } from "../onBoardingTemplateForms/TimeZoneDropdown";
import { ScheduledWorkflows } from "./ScheduledWorkflows";

// Start/End time of call used to be a fixed hourly dropdown (08AM-10PM). Backend parsing
// (scheduleTimeUtils.js's parseScheduleTime) already tolerates an optional ":MM" - these just
// split/join that same "HH:MM AM/PM" string into three flexible dropdowns instead of one fixed one.
const parseTimeParts = (value) => {
    const match = /^\s*(\d{1,2})(?::(\d{2}))?\s*(AM|PM)\s*$/i.exec(String(value || ""));
    if (!match) {
        return { hour: "08", minute: "00", meridiem: "AM" };
    }
    return {
        hour: match[1].padStart(2, "0"),
        minute: (match[2] || "00").padStart(2, "0"),
        meridiem: match[3].toUpperCase(),
    };
};
const formatTimeParts = (hour, minute, meridiem) => `${hour}:${minute} ${meridiem}`;
const HOURS_12 = Array.from({ length: 12 }, (_, i) => String(i + 1).padStart(2, "0"));
const MINUTES_60 = Array.from({ length: 60 }, (_, i) => String(i).padStart(2, "0"));

export const GeneralCallSetting = () => {
    const [providerDetail, setProviderDetail] = useState([]);
    const [patientDetail, setPatientDetail] = useState([]);
    const [isTimeEqual, setIsTimeEqual] = useState(false);
    const [isTimeAndBatchWrong, setIsTimeAndBatchWrong] = useState(false);
    const [isBatchTime, setIsBatchTime] = useState(false);
    const [isFieldsEmpty, setIsFieldsEmpty] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { PracticeId, activeTab, activeOnBoardingTem, setActiveOnBoardingTem, sideBarLinkActive, dayOfCall, dateRangeRequest,
        followUpCalls, timeOfCall, callAttemptsPerDay, doNotCallList, callSettingsData, fetchApiHandle, setCallSettingsData, setDoNotCallList,
        setCallAttemptsPerDay, setTimeOfCall, setFollowUpCalls, setDayOfCall, memberDoNotCallList, setMemberDoNotCallList,
        memberCallSettingsData, setMemberCallSettingsData, memberCallAttemptsPerDay, setMemberCallAttemptsPerDay, practiceContactNumber,
        memberTimeOfCall, setMemberTimeOfCall, memberFollowUpCalls, setMemberFollowUpCalls, memberDayOfCall, setMemberDayOfCall,
        memberPatientName, setMemberPatientName, memberProviderName, setMemberProviderName, token, setToken, usersPostRequest,
        updateRequest, fetchUserRecord, activeUploadLead, userType, setDateUrl, setUserType, setActiveTab,
        startTimeOfCall, setStartTimeOfCall, endTimeOfCall, setEndTimeOfCall, concurrentCalls, setConcurrentCalls,
        batchTimeBetweenCalls, setBatchTimeBetweenCalls, selectedTimezone, setSelectedTimezone,
        outBoundContact } = useContextStateManagement();
    let doNotCall = document.getElementById('doNotCallList');
    let callAttempts = document.getElementById('callAttemptsPerDay');
    let concurrentCall = document.getElementById('concurrentCalls');
    let batchTime = document.getElementById('batchTime');
    let callsfollowUp = document.getElementById('followUpCalls');
    let dayCall = document.getElementById('dayOfCall');
    let selected_timezone = document.getElementById('selected_timezone');
    let patientName = document.getElementById('patientName');
    let memberProviderDetails = document.getElementById('providerDetails')
    let memberDoNotCall = document.getElementById('memberDoNotCallList');
    let memberCallAttempts = document.getElementById('memberCallAttemptsPerDay');
    let memberCallTime = document.getElementById('memberTimeOfCall');
    let memberCallsfollowUp = document.getElementById('memberFollowUpCalls');
    let memberCallDay = document.getElementById('memberDayOfCall');
    let weekDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];
    const [isTokenExpired, setIsTokenExpired] = useState(false);

    const handleTimezoneChange = (e) => {
        setSelectedTimezone(e.target.value);
    };

    const fetchPatientsHandle = async () => {
        let userData;
        let url;
        let obj;

        if (userType === "admin") {
            if (activeTab === "leadGTab") {
                url = `/api/getLeadGenerationUploadLead`;
            }
            else if (activeTab === "uatTab") {
                setDateUrl(`/api/SearchDateUatTest`);
            }
            else {
                // "inBoundCalls", "summaryTab", or anything else left over in
                // context from whichever console tab was active before the user
                // navigated here (Call Settings isn't itself a tab, and clicking
                // it from the sidebar never resets activeTab - see Sidebar.jsx's
                // callSettingsHandle) - default to the inbound leads endpoint
                // instead of leaving url undefined and silently breaking this
                // dropdown for anyone who got here from a tab other than
                // Inbound/Outbound (e.g. Summary).
                url = `/api/PriorAuthQLead`;
            }
        }

        if (activeUploadLead === "/api/getLeadGenerationUploadLead" || url === "/api/getLeadGenerationUploadLead") {
            obj = { PracticeId, practiceContactNumber };
            userData = await dateRangeRequest(token, activeUploadLead, obj);
        }
        else if (activeUploadLead === "/api/PriorAuthQLead" || url === "/api/PriorAuthQLead") {
            obj = { PracticeId, practiceContactNumber };
            userData = await dateRangeRequest(token, activeUploadLead, obj);
        }
        else {
            userData = await fetchUserRecord(token, userType === "admin" ? url : activeUploadLead);
        }

        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        } else if (userData == "no record") {
            setPatientDetail([])
        }
        else {
            setPatientDetail(userData)
        }
    }

    const fetchProvidersHandle = async () => {
        let url;

        if (userType === "admin") {
            if (activeTab === "leadGTab") {
                url = `/api/LeadGenerationOnboarding/${PracticeId}`;
            }
            else if (activeTab === "uatTab") {
                setDateUrl(`/api/SearchDateUatTest`);
            }
            else {
                // See the matching comment in fetchPatientsHandle - "inBoundCalls",
                // "summaryTab", or any other leftover activeTab defaults to the
                // inbound onboarding template instead of an undefined url.
                url = `/api/PAuthQOnBoardingTemplate/${PracticeId}`;
            }
        }

        const userData = await fetchUserRecord(token, userType === "admin" ? url : activeOnBoardingTem);
        if (userData == "Token is expired, login again") {
            setIsTokenExpired(true)
        }
        else if (activeTab === "uatTab") {
            setProviderDetail(userData)
        }
        else {
            // Every other tab (including "summaryTab") now resolves to an
            // endpoint shaped like { providersData: [...], functions: [...] } -
            // unwrap it the same way inBoundCalls/leadGTab always did.
            setProviderDetail(userData && userData.providersData ? userData.providersData : userData)
        }
    }

    const generalCallSettingHandle = async (e) => {
        e.target.disabled = true;

        if (!startTimeOfCall || !endTimeOfCall || !selectedTimezone || dayOfCall.length === 0) {
            setIsFieldsEmpty(true);

            setTimeout(() => {
                setIsFieldsEmpty(false);
            }, 5000);

            e.target.disabled = false;

            return
        }

        // if (startTimeOfCall == endTimeOfCall && batchTimeBetweenCalls < 10) {
        if (startTimeOfCall == endTimeOfCall) {
            setIsTimeAndBatchWrong(true);

            setTimeout(() => {
                setIsTimeAndBatchWrong(false);
            }, 5000);

            e.target.disabled = false;

            return
        }
        else {
            if (startTimeOfCall == endTimeOfCall) {
                setIsTimeEqual(true);

                setTimeout(() => {
                    setIsTimeEqual(false);
                }, 5000);

                e.target.disabled = false;

                return
            }

            // if (batchTimeBetweenCalls < 10) {
            //     setIsBatchTime(true);

            //     setTimeout(() => {
            //         setIsBatchTime(false);
            //     }, 5000);

            //     e.target.disabled = false;

            //     return
            // }
        }


        if (callSettingsData.length > 0) {

            let obj = {
                Id: callSettingsData[0].Id,
                PracticeId: PracticeId,
                DoNotCallList: doNotCall.value,
                NumberOfCallAttemptPerDays: callAttempts.value,
                StartTimeOfCall: startTimeOfCall,
                EndTimeOfCall: endTimeOfCall,
                ConcurrentCalls: concurrentCall.value,
                BatchCallsTime: batchTime.value,
                FollowUpCallRelation: callsfollowUp.value,
                DayOfCall: dayOfCall,
                SelectedTimezone: selectedTimezone,
            }

            let url = `/api/GeneralCallSettings/${callSettingsData[0].Id}`;
            const userData = await updateRequest(token, url, obj);
            if (userData == "Token is expired, login again") {
                setIsTokenExpired(true)
            }
            else if (userData && userData.message) {
                fetchApiHandle("generalCallSettings");
                alert(userData.message)
            }

        } else {

            let obj = {
                PracticeId: PracticeId,
                DoNotCallList: doNotCall.value,
                NumberOfCallAttemptPerDays: callAttempts.value,
                StartTimeOfCall: startTimeOfCall,
                EndTimeOfCall: endTimeOfCall,
                ConcurrentCalls: concurrentCall.value,
                BatchCallsTime: batchTime.value,
                FollowUpCallRelation: callsfollowUp.value,
                DayOfCall: dayOfCall,
                SelectedTimezone: selectedTimezone,
            }

            let url = '/api/GeneralCallSettings';
            const userData = await usersPostRequest(token, url, obj);
            if (userData == "Token is expired, login again") {
                setIsTokenExpired(true)
            }
            else if (userData && userData.message) {
                fetchApiHandle("generalCallSettings");
                alert(userData.message)
            }
        }
        e.target.disabled = false;
    }

    const specificMemberCallSettingHandle = async () => {
        if (memberCallSettingsData.length > 0) {
            let obj = {
                Id: memberCallSettingsData[0].Id,
                PracticeId: PracticeId,
                PatientName: patientName.value,
                ProviderDetails: memberProviderDetails.value,
                DoNotCallList: memberDoNotCall.value,
                NumberOfCallAttemptPerDays: memberCallAttempts.value,
                TimeOfCall: memberCallTime.value,
                FollowUpCallRelation: memberCallsfollowUp.value,
                DayOfCall: memberDayOfCall
            }

            let url = `/api/CallSettingsMemberListWise/${memberCallSettingsData[0].Id}`;
            const userData = await updateRequest(token, url, obj);
            if (userData == "Token is expired, login again") {
                setIsTokenExpired(true)
            }
            else if (userData && userData.message) {
                fetchApiHandle("CallSettingsMemberListWise");
                alert(userData.message)
            }

        } else {

            let obj = {
                PracticeId: PracticeId,
                PatientName: patientName.value,
                ProviderDetails: memberProviderDetails.value,
                DoNotCallList: memberDoNotCall.value,
                NumberOfCallAttemptPerDays: memberCallAttempts.value,
                TimeOfCall: memberCallTime.value,
                FollowUpCallRelation: memberCallsfollowUp.value,
                DayOfCall: memberDayOfCall
            }

            let url = `/api/CallSettingsMemberListWise`;
            const userData = await usersPostRequest(token, url, obj);
            if (userData == "Token is expired, login again") {
                setIsTokenExpired(true)
            }
            else if (userData && userData.message) {
                fetchApiHandle("CallSettingsMemberListWise");
                alert(userData.message)
            }
        }
    }

    useEffect(() => {
        if (activeTab || PracticeId) {
            fetchProvidersHandle()
            fetchPatientsHandle()
        }
    }, [activeTab, PracticeId])

    // Token-expiry redirect is now handled once, centrally, in ContextApi.js - this component
    // used to have its own copy of that same effect (alert + cleanup + navigate), which meant a
    // single expiry could pop more than one alert() at once across every mounted component that
    // had this duplicate.

    return (
        <>
            <div className="row" id="callSettingGrid" >
                <div className="col-lg-12 overflow-auto" id="">
                    <div>
                        <div id="pAuthQCallSettingTable" className="pAuthQ-callSetting-table">
                            <p className="heading">General Call Settings for AI Calls</p>
                            <table className="table generalTable">
                                <thead>
                                    <tr className="call-row-heading">
                                        <th className="callSettingsHeading">Start time of call <span className="required-fields">*</span></th>
                                        <th className="callSettingsHeading">End time of <br /> call <span className="required-fields">*</span></th>
                                        <th className="callSettingsHeading">Fill concurrent call <span className="required-fields">*</span></th>
                                        <th className="callSettingsHeading">Fill call wait time between batches (minutes) <span className="required-fields">*</span></th>
                                        <th className="callSettingsHeading">Day of Call <span className="required-fields">*</span></th>
                                        <th className="callSettingsHeading">Select timezone <span className="required-fields timezone">*</span></th>
                                        <th className="callSettingsHeading text-white">Allow Calls</th>
                                        <th className="callSettingsHeading">Call Attempts/Day</th>
                                        <th className="callSettingsHeading">Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            {(() => {
                                                const { hour, minute, meridiem } = parseTimeParts(startTimeOfCall);
                                                return (
                                                    <div className="d-flex" style={{ gap: 4 }}>
                                                        <select className="form-select dropdownCallSettingsTimeOfCall" id="startTimeOfCallHour" value={hour}
                                                            onChange={(e) => setStartTimeOfCall(formatTimeParts(e.target.value, minute, meridiem))}>
                                                            {HOURS_12.map((h) => <option key={h} value={h}>{h}</option>)}
                                                        </select>
                                                        <select className="form-select dropdownCallSettingsTimeOfCall" id="startTimeOfCallMinute" value={minute}
                                                            onChange={(e) => setStartTimeOfCall(formatTimeParts(hour, e.target.value, meridiem))}>
                                                            {MINUTES_60.map((m) => <option key={m} value={m}>{m}</option>)}
                                                        </select>
                                                        <select className="form-select dropdownCallSettingsTimeOfCall" id="startTimeOfCallMeridiem" value={meridiem}
                                                            onChange={(e) => setStartTimeOfCall(formatTimeParts(hour, minute, e.target.value))}>
                                                            <option value="AM">AM</option>
                                                            <option value="PM">PM</option>
                                                        </select>
                                                    </div>
                                                );
                                            })()}
                                            <button type="submit" className="mt-3 mb-1 simple-btn px-4" onClick={generalCallSettingHandle}>Save</button>
                                            <div className="position-relative">
                                                {
                                                    isTimeEqual && (
                                                        <div className="callTimeMsg position-absolute">End time must be greater than start time of call</div>
                                                    )
                                                }
                                                {
                                                    isTimeAndBatchWrong && (
                                                        <div className="callTimeMsg position-absolute">End time must be greater than start time and batch time minimum 10</div>
                                                    )
                                                }
                                                {
                                                    isBatchTime && (
                                                        <div className="callTimeMsg position-absolute">The time between batch calls must be at least 10 minutes</div>
                                                    )
                                                }
                                                {
                                                    isFieldsEmpty && (
                                                        <div className="callTimeMsg position-absolute">Please fill all the required fields</div>
                                                    )
                                                }
                                            </div>
                                        </td>
                                        <td>
                                            {(() => {
                                                const { hour, minute, meridiem } = parseTimeParts(endTimeOfCall);
                                                return (
                                                    <div className="d-flex" style={{ gap: 4 }}>
                                                        <select className="form-select dropdownCallSettingsTimeOfCall" id="endTimeOfCallHour" value={hour}
                                                            onChange={(e) => setEndTimeOfCall(formatTimeParts(e.target.value, minute, meridiem))}>
                                                            {HOURS_12.map((h) => <option key={h} value={h}>{h}</option>)}
                                                        </select>
                                                        <select className="form-select dropdownCallSettingsTimeOfCall" id="endTimeOfCallMinute" value={minute}
                                                            onChange={(e) => setEndTimeOfCall(formatTimeParts(hour, e.target.value, meridiem))}>
                                                            {MINUTES_60.map((m) => <option key={m} value={m}>{m}</option>)}
                                                        </select>
                                                        <select className="form-select dropdownCallSettingsTimeOfCall" id="endTimeOfCallMeridiem" value={meridiem}
                                                            onChange={(e) => setEndTimeOfCall(formatTimeParts(hour, minute, e.target.value))}>
                                                            <option value="AM">AM</option>
                                                            <option value="PM">PM</option>
                                                        </select>
                                                    </div>
                                                );
                                            })()}
                                        </td>
                                        <td>
                                            <select className="form-select dropdownCallSettingsTimeOfCall" id="concurrentCalls" value={concurrentCalls} onChange={(e) => setConcurrentCalls(e.target.value)}>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                                <option value="4">4</option>
                                                <option value="5">5</option>
                                                <option value="6">6</option>
                                                <option value="7">7</option>
                                                <option value="8">8</option>
                                                <option value="9">9</option>
                                                <option value="10">10</option>
                                                <option value="20">20</option>
                                                <option value="30">30</option>
                                                <option value="40">40</option>
                                                <option value="50">50</option>
                                                <option value="60">60</option>
                                                <option value="70">70</option>
                                                <option value="80">80</option>
                                                <option value="90">90</option>
                                                <option value="100">100</option>
                                            </select>
                                        </td>
                                        <td>
                                            <input style={{ height: 32 }} type="text" id="batchTime" value={batchTimeBetweenCalls} onChange={(e) => setBatchTimeBetweenCalls(e.target.value)} className="form-control" placeholder="Enter gap" />
                                        </td>
                                        <td>
                                            <Autocomplete
                                                sx={{
                                                    // "& .MuiOutlinedInput-root": {
                                                    //     backgroundColor: "#e9ecef",
                                                    // },
                                                    // "& .MuiAutocomplete-popupIndicator": {
                                                    //     color: "#000",
                                                    // },
                                                    // "& .MuiSvgIcon-root": {
                                                    //     color: "#000", // just in case
                                                    // }, 
                                                    backgroundColor: "#fff", color: "#000", height: 32, width: 275, borderRadius: ".25rem",
                                                    "& .MuiAutocomplete-clearIndicator": {
                                                        color: "#000 !important", // icon color
                                                        backgroundColor: "#f0f0f0 !important", // background color
                                                        borderRadius: "50%", // optional, makes it a circle
                                                        "&:hover": {
                                                            backgroundColor: "#d6d6d6",
                                                        }
                                                    },
                                                }}
                                                multiple
                                                id="dayOfCall"
                                                value={dayOfCall}
                                                onChange={(event, newValue) => {
                                                    setDayOfCall(newValue);
                                                }}
                                                popupIcon={< KeyboardArrowDownOutlinedIcon />}
                                                options={weekDays}
                                                getOptionLabel={(option) => option}
                                                disableCloseOnSelect
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // variant="outlined"
                                                        className="textField"
                                                        placeholder="Select Days of Call ..."
                                                        size="small"
                                                        color="secondary"
                                                    />
                                                )}
                                                renderOption={(props, option, { selected }) => (
                                                    <MenuItem
                                                        {...props}
                                                        key={option}
                                                        value={option}
                                                        sx={{ fontSize: "0.75rem", justifyContent: "space-between" }}
                                                    >
                                                        {option}
                                                        {selected ? <CheckIcon color="info" /> : null}
                                                    </MenuItem>
                                                )}
                                            />

                                        </td>
                                        <td style={{ width: "200px" }}>
                                            <TimeZoneDropdown isBgBlack={false} selectedTimezone={selectedTimezone} onChange={handleTimezoneChange} />
                                        </td>
                                        <td>
                                            <select disabled className="form-select disabled-Input-color" value={doNotCallList} onChange={(e) => setDoNotCallList(e.target.value)} id="doNotCallList">
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select disabled className="form-select disabled-Input-color" id="callAttemptsPerDay" value={callAttemptsPerDay} onChange={(e) => setCallAttemptsPerDay(e.target.value)}>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select disabled className="form-select disabled-Input-color dropdownCallSettingsFollowUpCall" id="followUpCalls" value={followUpCalls} onChange={(e) => setFollowUpCalls(e.target.value)}>
                                                <option value="1extraday">1 extra day</option>
                                                <option value="2days">2 days</option>
                                                <option value="3days">3 days</option>
                                                <option value="4days">4 days</option>
                                                <option value="5days">5 days</option>
                                                <option value="1week">1 week</option>
                                                <option value="2weeks">2 weeks</option>
                                                <option value="nofollowup">No Follow up once the conversation is done</option>
                                                <option value="nofollowupatall">No follow up at all</option>
                                            </select>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                            <p className="heading">Specific Member Settings for AI Calls</p>
                            <table className="table">
                                <thead>
                                    <tr className="call-row-heading">
                                        <th className="callSettingsHeading">Patient Name</th>
                                        <th className="callSettingsHeading">Provider Details</th>
                                        <th className="callSettingsHeading">Allow Calls</th>
                                        <th className="callSettingsHeading">Call Attempts/Day</th>
                                        <th className="callSettingsHeading">Time of Call (CST)</th>
                                        <th className="callSettingsHeading">Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                        <th className="callSettingsHeading">Day of Call</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td>
                                            <select className="form-select" id="patientName" value={memberPatientName} onChange={(e) => setMemberPatientName(e.target.value)}>
                                                {
                                                    Array.isArray(patientDetail) && patientDetail.length > 0 ?
                                                        patientDetail.map((patient) => {
                                                            return (
                                                                <option key={patient.Id} value={patient.Id}>{patient.PatientFullName || `${patient.CallerFirstName || ""} ${patient.CallerLastName || ""}`.trim()}</option>
                                                            )
                                                        })
                                                        : ""
                                                }
                                            </select>
                                            <button type="submit" className="mt-3 mb-1 simple-btn px-4" onClick={specificMemberCallSettingHandle}>Save</button>
                                        </td>
                                        <td>
                                            <select className="form-select" id="providerDetails" value={memberProviderName} onChange={(e) => setMemberProviderName(e.target.value)}>
                                                {
                                                    Array.isArray(providerDetail) && providerDetail.length > 0 ?
                                                        providerDetail.map((provider) => {
                                                            return (
                                                                <option key={provider.Id} value={provider.Id}>{provider.ProviderName}</option>
                                                            )
                                                        })
                                                        : ""
                                                }
                                            </select>
                                        </td>
                                        <td>
                                            <select className="form-select" id="memberDoNotCallList" value={memberDoNotCallList} onChange={(e) => setMemberDoNotCallList(e.target.value)}>
                                                <option value="false">No</option>
                                                <option value="true">Yes</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select className="form-select" id="memberCallAttemptsPerDay" value={memberCallAttemptsPerDay} onChange={(e) => setMemberCallAttemptsPerDay(e.target.value)}>
                                                <option value="1">1</option>
                                                <option value="2">2</option>
                                                <option value="3">3</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select className="form-select dropdownCallSettingsTimeOfCall" id="memberTimeOfCall" value={memberTimeOfCall} onChange={(e) => setMemberTimeOfCall(e.target.value)}>
                                                <option value="08AM">08 AM</option>
                                                <option value="09AM">09 AM</option>
                                                <option value="10AM">10 AM</option>
                                                <option value="11AM">11 AM</option>
                                                <option value="12AM">12 AM</option>
                                                <option value="01PM">01 PM</option>
                                                <option value="02PM">02 PM</option>
                                                <option value="03PM">03 PM</option>
                                                <option value="04PM">04 PM</option>
                                                <option value="05PM">05 PM</option>
                                                <option value="06PM">06 PM</option>
                                                <option value="07PM">07 PM</option>
                                                <option value="08PM">08 PM</option>
                                                <option value="09PM">09 PM</option>
                                                <option value="10PM">10 PM</option>
                                            </select>
                                        </td>
                                        <td>
                                            <select className="form-select dropdownCallSettingsFollowUpCall" id="memberFollowUpCalls" value={memberFollowUpCalls} onChange={(e) => setMemberFollowUpCalls(e.target.value)}>
                                                <option value="1extraday">1 extra day</option>
                                                <option value="2days">2 days</option>
                                                <option value="3days">3 days</option>
                                                <option value="4days">4 days</option>
                                                <option value="5days">5 days</option>
                                                <option value="1week">1 week</option>
                                                <option value="2weeks">2 weeks</option>
                                                <option value="nofollowup">No Follow up once the conversation is done</option>
                                                <option value="nofollowupatall">No follow up at all</option>
                                            </select>
                                        </td>
                                        <td className="multiSelectDaysList">
                                            <Autocomplete
                                                sx={{ backgroundColor: "#fff", height: 32, width: 275, borderRadius: ".25rem" }}
                                                multiple
                                                id="memberDayOfCall"
                                                value={memberDayOfCall}
                                                onChange={(event, newValue) => {
                                                    setMemberDayOfCall(newValue);
                                                }}
                                                popupIcon={< KeyboardArrowDownOutlinedIcon />}
                                                options={weekDays}
                                                getOptionLabel={(option) => option}
                                                disableCloseOnSelect
                                                renderInput={(params) => (
                                                    <TextField
                                                        {...params}
                                                        // variant="outlined"
                                                        className="textField"
                                                        placeholder="Select Days of Call ..."
                                                        size="small"
                                                        autoFocus
                                                    // defaultValue="Small"
                                                    />
                                                )}
                                                renderOption={(props, option, { selected }) => (
                                                    <MenuItem
                                                        {...props}
                                                        key={option}
                                                        value={option}
                                                        sx={{ fontSize: "0.75rem", justifyContent: "space-between" }}
                                                    >
                                                        {option}
                                                        {selected ? <CheckIcon color="info" /> : null}
                                                    </MenuItem>
                                                )}
                                            />
                                        </td>
                                    </tr>
                                </tbody>
                            </table>

                            <ScheduledWorkflows />
                        </div>

                        <table className="table" id="pAuthStatusCallSettingTable" style={{ display: "none" }}>
                            <thead>

                                <tr className="call-row-heading">
                                    <th>Do Not Call the list</th>
                                    <th>Call Attempts/Day</th>
                                    <th>Time of Call (CST)</th>
                                    <th>Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    <th>Day of Call</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-select">
                                            <option value="No">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsTimeOfCall" >
                                            <option value="08AM">08 AM</option>
                                            <option value="09AM">09 AM</option>
                                            <option value="10AM">10 AM</option>
                                            <option value="11AM">11 AM</option>
                                            <option value="12AM">12 AM</option>
                                            <option value="01PM">01 PM</option>
                                            <option value="02PM">02 PM</option>
                                            <option value="03PM">03 PM</option>
                                            <option value="04PM">04 PM</option>
                                            <option value="05PM">05 PM</option>
                                            <option value="06PM">06 PM</option>
                                            <option value="07PM">07 PM</option>
                                            <option value="08PM">08 PM</option>
                                            <option value="09PM">09 PM</option>
                                            <option value="10PM">10 PM</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsFollowUpCall">
                                            <option value="1extraday">1 extra day</option>
                                            <option value="2days">2 days</option>
                                            <option value="3days">3 days</option>
                                            <option value="4days">4 days</option>
                                            <option value="5days">5 days</option>
                                            <option value="1week">1 week</option>
                                            <option value="2weeks">2 weeks</option>
                                            <option value="nofollowup">No Follow up once the conversation is done</option>
                                            <option value="nofollowupatall">No follow up at all</option>
                                        </select>
                                    </td>
                                    <td className="multiSelectDaysList">
                                        <select className="form-select" id="pAuthStatusMultiSelectDays" multiple="multiple" data-placeholder="Select Days of Call . . .">
                                            <option>Monday</option>
                                            <option>Tuesday</option>
                                            <option>Wednesday</option>
                                            <option>Thursday</option>
                                            <option>Friday</option>
                                            <option>Saturday</option>
                                            <option>Sunday</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="table" id="benefitVCallSettingTable" style={{ display: "none" }}>
                            <thead>

                                <tr className="call-row-heading">
                                    <th>Do Not Call the list</th>
                                    <th>Call Attempts/Day</th>
                                    <th>Time of Call (CST)</th>
                                    <th>Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    <th>Day of Call</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-select">
                                            <option value="No">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsTimeOfCall" >
                                            <option value="08AM">08 AM</option>
                                            <option value="09AM">09 AM</option>
                                            <option value="10AM">10 AM</option>
                                            <option value="11AM">11 AM</option>
                                            <option value="12AM">12 AM</option>
                                            <option value="01PM">01 PM</option>
                                            <option value="02PM">02 PM</option>
                                            <option value="03PM">03 PM</option>
                                            <option value="04PM">04 PM</option>
                                            <option value="05PM">05 PM</option>
                                            <option value="06PM">06 PM</option>
                                            <option value="07PM">07 PM</option>
                                            <option value="08PM">08 PM</option>
                                            <option value="09PM">09 PM</option>
                                            <option value="10PM">10 PM</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsFollowUpCall">
                                            <option value="1extraday">1 extra day</option>
                                            <option value="2days">2 days</option>
                                            <option value="3days">3 days</option>
                                            <option value="4days">4 days</option>
                                            <option value="5days">5 days</option>
                                            <option value="1week">1 week</option>
                                            <option value="2weeks">2 weeks</option>
                                            <option value="nofollowup">No Follow up once the conversation is done</option>
                                            <option value="nofollowupatall">No follow up at all</option>
                                        </select>
                                    </td>
                                    <td className="multiSelectDaysList">
                                        <select className="form-select" id="benefitVMultiSelectDays" multiple="multiple" data-placeholder="Select Days of Call . . .">
                                            <option>Monday</option>
                                            <option>Tuesday</option>
                                            <option>Wednesday</option>
                                            <option>Thursday</option>
                                            <option>Friday</option>
                                            <option>Saturday</option>
                                            <option>Sunday</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="table" id="careRCallSettingTable" style={{ display: "none" }}>
                            <thead>

                                <tr className="call-row-heading">
                                    <th>Do Not Call the list</th>
                                    <th>Call Attempts/Day</th>
                                    <th>Time of Call (CST)</th>
                                    <th>Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    <th>Day of Call</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-select">
                                            <option value="No">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsTimeOfCall" >
                                            <option value="08AM">08 AM</option>
                                            <option value="09AM">09 AM</option>
                                            <option value="10AM">10 AM</option>
                                            <option value="11AM">11 AM</option>
                                            <option value="12AM">12 AM</option>
                                            <option value="01PM">01 PM</option>
                                            <option value="02PM">02 PM</option>
                                            <option value="03PM">03 PM</option>
                                            <option value="04PM">04 PM</option>
                                            <option value="05PM">05 PM</option>
                                            <option value="06PM">06 PM</option>
                                            <option value="07PM">07 PM</option>
                                            <option value="08PM">08 PM</option>
                                            <option value="09PM">09 PM</option>
                                            <option value="10PM">10 PM</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsFollowUpCall">
                                            <option value="1extraday">1 extra day</option>
                                            <option value="2days">2 days</option>
                                            <option value="3days">3 days</option>
                                            <option value="4days">4 days</option>
                                            <option value="5days">5 days</option>
                                            <option value="1week">1 week</option>
                                            <option value="2weeks">2 weeks</option>
                                            <option value="nofollowup">No Follow up once the conversation is done</option>
                                            <option value="nofollowupatall">No follow up at all</option>
                                        </select>
                                    </td>
                                    <td className="multiSelectDaysList">
                                        <select className="form-select" id="careRMultiSelectDays" multiple="multiple" data-placeholder="Select Days of Call . . .">
                                            <option>Monday</option>
                                            <option>Tuesday</option>
                                            <option>Wednesday</option>
                                            <option>Thursday</option>
                                            <option>Friday</option>
                                            <option>Saturday</option>
                                            <option>Sunday</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="table" id="visitRCallSettingTable" style={{ display: "none" }}>
                            <thead>

                                <tr className="call-row-heading">
                                    <th>Do Not Call the list</th>
                                    <th>Call Attempts/Day</th>
                                    <th>Time of Call (CST)</th>
                                    <th>Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    <th>Day of Call</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-select">
                                            <option value="No">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsTimeOfCall" >
                                            <option value="08AM">08 AM</option>
                                            <option value="09AM">09 AM</option>
                                            <option value="10AM">10 AM</option>
                                            <option value="11AM">11 AM</option>
                                            <option value="12AM">12 AM</option>
                                            <option value="01PM">01 PM</option>
                                            <option value="02PM">02 PM</option>
                                            <option value="03PM">03 PM</option>
                                            <option value="04PM">04 PM</option>
                                            <option value="05PM">05 PM</option>
                                            <option value="06PM">06 PM</option>
                                            <option value="07PM">07 PM</option>
                                            <option value="08PM">08 PM</option>
                                            <option value="09PM">09 PM</option>
                                            <option value="10PM">10 PM</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsFollowUpCall">
                                            <option value="1extraday">1 extra day</option>
                                            <option value="2days">2 days</option>
                                            <option value="3days">3 days</option>
                                            <option value="4days">4 days</option>
                                            <option value="5days">5 days</option>
                                            <option value="1week">1 week</option>
                                            <option value="2weeks">2 weeks</option>
                                            <option value="nofollowup">No Follow up once the conversation is done</option>
                                            <option value="nofollowupatall">No follow up at all</option>
                                        </select>
                                    </td>
                                    <td className="multiSelectDaysList">
                                        <select className="form-select" id="visitRMultiSelectDays" multiple="multiple" data-placeholder="Select Days of Call . . .">
                                            <option>Monday</option>
                                            <option>Tuesday</option>
                                            <option>Wednesday</option>
                                            <option>Thursday</option>
                                            <option>Friday</option>
                                            <option>Saturday</option>
                                            <option>Sunday</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="table" id="awareCCallSettingTable" style={{ display: "none" }}>
                            <thead>

                                <tr className="call-row-heading">
                                    <th>Do Not Call the list</th>
                                    <th>Call Attempts/Day</th>
                                    <th>Time of Call (CST)</th>
                                    <th>Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    <th>Day of Call</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-select">
                                            <option value="No">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsTimeOfCall" >
                                            <option value="08AM">08 AM</option>
                                            <option value="09AM">09 AM</option>
                                            <option value="10AM">10 AM</option>
                                            <option value="11AM">11 AM</option>
                                            <option value="12AM">12 AM</option>
                                            <option value="01PM">01 PM</option>
                                            <option value="02PM">02 PM</option>
                                            <option value="03PM">03 PM</option>
                                            <option value="04PM">04 PM</option>
                                            <option value="05PM">05 PM</option>
                                            <option value="06PM">06 PM</option>
                                            <option value="07PM">07 PM</option>
                                            <option value="08PM">08 PM</option>
                                            <option value="09PM">09 PM</option>
                                            <option value="10PM">10 PM</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsFollowUpCall">
                                            <option value="1extraday">1 extra day</option>
                                            <option value="2days">2 days</option>
                                            <option value="3days">3 days</option>
                                            <option value="4days">4 days</option>
                                            <option value="5days">5 days</option>
                                            <option value="1week">1 week</option>
                                            <option value="2weeks">2 weeks</option>
                                            <option value="nofollowup">No Follow up once the conversation is done</option>
                                            <option value="nofollowupatall">No follow up at all</option>
                                        </select>
                                    </td>
                                    <td className="multiSelectDaysList">
                                        <select className="form-select" id="awareCMultiSelectDays" multiple="multiple" data-placeholder="Select Days of Call . . .">
                                            <option>Monday</option>
                                            <option>Tuesday</option>
                                            <option>Wednesday</option>
                                            <option>Thursday</option>
                                            <option>Friday</option>
                                            <option>Saturday</option>
                                            <option>Sunday</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="table" id="leadGCallSettingTable" style={{ display: "none" }}>
                            <thead>

                                <tr className="call-row-heading">
                                    <th>Do Not Call the list</th>
                                    <th>Call Attempts/Day</th>
                                    <th>Time of Call (CST)</th>
                                    <th>Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    <th>Day of Call</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-select">
                                            <option value="No">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsTimeOfCall" >
                                            <option value="08AM">08 AM</option>
                                            <option value="09AM">09 AM</option>
                                            <option value="10AM">10 AM</option>
                                            <option value="11AM">11 AM</option>
                                            <option value="12AM">12 AM</option>
                                            <option value="01PM">01 PM</option>
                                            <option value="02PM">02 PM</option>
                                            <option value="03PM">03 PM</option>
                                            <option value="04PM">04 PM</option>
                                            <option value="05PM">05 PM</option>
                                            <option value="06PM">06 PM</option>
                                            <option value="07PM">07 PM</option>
                                            <option value="08PM">08 PM</option>
                                            <option value="09PM">09 PM</option>
                                            <option value="10PM">10 PM</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsFollowUpCall">
                                            <option value="1extraday">1 extra day</option>
                                            <option value="2days">2 days</option>
                                            <option value="3days">3 days</option>
                                            <option value="4days">4 days</option>
                                            <option value="5days">5 days</option>
                                            <option value="1week">1 week</option>
                                            <option value="2weeks">2 weeks</option>
                                            <option value="nofollowup">No Follow up once the conversation is done</option>
                                            <option value="nofollowupatall">No follow up at all</option>
                                        </select>
                                    </td>
                                    <td className="multiSelectDaysList">
                                        <select className="form-select" id="leadGMultiSelectDays" multiple="multiple" data-placeholder="Select Days of Call . . .">
                                            <option>Monday</option>
                                            <option>Tuesday</option>
                                            <option>Wednesday</option>
                                            <option>Thursday</option>
                                            <option>Friday</option>
                                            <option>Saturday</option>
                                            <option>Sunday</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                        <table className="table" id="surveyCallSettingTable" style={{ display: "none" }}>
                            <thead>

                                <tr className="call-row-heading">
                                    <th>Do Not Call the list</th>
                                    <th>Call Attempts/Day</th>
                                    <th>Time of Call (CST)</th>
                                    <th>Follow up Call if the first call was busy or missed or not connected in the first attempt 2 days</th>
                                    <th>Day of Call</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <select className="form-select">
                                            <option value="No">No</option>
                                            <option value="yes">Yes</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select">
                                            <option value="1">1</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsTimeOfCall" >
                                            <option value="08AM">08 AM</option>
                                            <option value="09AM">09 AM</option>
                                            <option value="10AM">10 AM</option>
                                            <option value="11AM">11 AM</option>
                                            <option value="12AM">12 AM</option>
                                            <option value="01PM">01 PM</option>
                                            <option value="02PM">02 PM</option>
                                            <option value="03PM">03 PM</option>
                                            <option value="04PM">04 PM</option>
                                            <option value="05PM">05 PM</option>
                                            <option value="06PM">06 PM</option>
                                            <option value="07PM">07 PM</option>
                                            <option value="08PM">08 PM</option>
                                            <option value="09PM">09 PM</option>
                                            <option value="10PM">10 PM</option>
                                        </select>
                                    </td>
                                    <td>
                                        <select className="form-select dropdownCallSettingsFollowUpCall">
                                            <option value="1extraday">1 extra day</option>
                                            <option value="2days">2 days</option>
                                            <option value="3days">3 days</option>
                                            <option value="4days">4 days</option>
                                            <option value="5days">5 days</option>
                                            <option value="1week">1 week</option>
                                            <option value="2weeks">2 weeks</option>
                                            <option value="nofollowup">No Follow up once the conversation is done</option>
                                            <option value="nofollowupatall">No follow up at all</option>
                                        </select>
                                    </td>
                                    <td className="multiSelectDaysList">
                                        <select className="form-select" id="surveyMultiSelectDays" multiple="multiple" data-placeholder="Select Days of Call . . .">
                                            <option>Monday</option>
                                            <option>Tuesday</option>
                                            <option>Wednesday</option>
                                            <option>Thursday</option>
                                            <option>Friday</option>
                                            <option>Saturday</option>
                                            <option>Sunday</option>
                                        </select>
                                    </td>
                                </tr>
                            </tbody>
                        </table>

                    </div>
                </div>
            </div>
        </>
    )
}
